import store from '../store';
import {PAGE_LOADED, PAGE_LOADING} from "../store/actions/page";

export const formatDecimal = function (val, cantDecimales) {
    var d = parseFloat(val);
    if (!isNaN(d)) {
        return d.toFixed(cantDecimales ? cantDecimales : 2);
    } else {
        return '';
    }
};

export const loading = (val) => {
    if (val)
        store.dispatch(PAGE_LOADING);
    else
        store.dispatch(PAGE_LOADED)
};


export const getFileName = (response) => {
    const contentDisposition = response.headers['content-disposition'];
    return contentDisposition.substr(contentDisposition.indexOf('filename=') + 9);
};



// WEBPACK FOOTER //
// ./src/util/util.js